<template>
    <b-modal
        id="modalmmsearch"
        ref="modalmmsearch"
        :lazy="true"
        title-tag="h3"
        hide-footer
        size="lg"
        title="Search Merck Veterinary Manual"
        centered
    >
        <div class="modal-body" style="min-height: 5rem;">
            <div id="mmsearchwidget">
                <div class="searchWrapper clearfix">
                    <a href="http://www.merckvetmanual.com" target="_blank">
                        <h1
                            class="brandLogo"
                            style="
                                background-image: url('assets/mvm_logo.png');
                            "
                        ></h1>
                    </a>
                    <div class="formFields">
                        <div class="textField">
                            <input
                                name="queryTerms"
                                v-model="query"
                                type="text"
                                class="searchTextField"
                                id="queryTerms"
                                placeholder="Search MerckVetmanual.com"
                                v-on:keyup.enter="search()"
                            />
                        </div>
                        <div class="searchButton">
                            <input
                                type="submit"
                                value="Search"
                                @click="search()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </b-modal>
</template>
<style>
@media only screen and (min-width: 1240px) {
    #modalmmsearch .searchWrapper .textField {
        width: 90%;
    }
}

@media (max-width: 979px) {
    #modalmmsearch.modal.fade.in {
        top: 0px;
        left: 0px;
    }
}

@media only screen and (max-width: 1240px) {
    .row-fluid div.header-dropdown-menu.span4 {
        width: auto;
    }
}

@media only screen and (max-width: 1240px) and (min-width: 780px) {
    #modalmmsearch .searchWrapper .textField {
        width: 90% !important;
    }
}

#modalmmsearch .searchWrapper .textField {
    width: 90% !important;
    display: flex;
    height: 40px;
    padding: 5px 0px;
    margin-left: 5px;
}

#modalmmsearch .modal-body {
    background-color: #0f7c54;
    padding: 0px;
    padding-top: 10px;
}
#modalmmsearch .formFields {
    width: 76%;
    display: flex;
    align-items: center;
    justify-content: stretch;
    padding-right: 5px;
}

#modalmmsearch .formFields .searchTextField {
    margin: 0px;
    border: 0;
    box-shadow: none;
    transition: none;
    flex-grow: 1;

    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}

#modalmmsearch .formFields .searchButton {
    margin: 0px;
    text-align: right;
}

#modalmmsearch .formFields .searchButton input {
    height: 32px;
    color: #fff;
    background: #505158;
    border: 1px solid #505158;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}

#modalmmsearch .searchWrapper {
    display: flex;
    justify-content: center;
}

.searchWrapper .brandLogo {
    background: transparent
        url("https://www.merckvetmanual.com/Content/Images/Redesign/mm_logo.svg")
        no-repeat;
    background-size: contain;
    background-position: bottom;
    text-indent: -999px;
    overflow: hidden;
    margin: 0;
    height: 40px;
    width: 160px;
    float: left;
}
</style>

<script>
export default {
    data() {
        return {
            query: null
        };
    },
    mounted() {
        // this.addScript('//merckbooks.com/vetsearchwidget/vetsearchwidgethSSL.js?query=vetterSoftware')
        // skip retrieving code from merck site because not working in production
        // can refer branch 2733 for previous code
    },
    methods: {
        search() {
            let searchLink =
                "https://www.merckvetmanual.com/SearchResults?query=" +
                this.query +
                "&utm_source=vetterSoftware&utm_medium=Partner&utm_campaign=Widget";
            window.open(searchLink, "_blank");

            this.query = null;
        }
    }
};
</script>
